export default __webpack_public_path__ + "static/media/list.2d3081c4.svg";